import { render, staticRenderFns } from "./MoneyMontoComponent.vue?vue&type=template&id=564b61a2&scoped=true"
import script from "./MoneyMontoComponent.vue?vue&type=script&lang=js"
export * from "./MoneyMontoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b61a2",
  null
  
)

export default component.exports